module.exports = __webpack_public_path__ + "img/KSC04990.45d42e50.jpg";